(function($) {
	'use strict';

	function initSlider( container, options ) {
		var tnsSlider = tns( $.extend( { container: container }, options ) );
		window.initTnsAccessibility( tnsSlider );
		return tnsSlider;
	}

	$(document).ready(function() {
		$('.single-item-slider').each(function() {
			initSlider( this, {
				items: 1,
				slideBy: 1,
				autoplay: false,
				autoHeight: true,
				controls: false,
				navPosition: "bottom",
				center: true,
				mouseDrag: true,
			} );
		});

		$('.timeline-blocks').each(function() {
			initSlider( this, {
				items: 1,
				slideBy: 1,
				autoplay: false,
				autoHeight: false,
				controls: true,
				nav: false,
				navPosition: "bottom",
				loop: false,
				mouseDrag: true,
				responsive: {
					768: {
						items: 2
					},
					1024: {
						items: 3
					}
				}
			} );
		});

		$('.image-gallery-two-column').each(function() {
			initSlider( this, {
				items: 1,
				slideBy: 1,
				autoplay: false,
				autoHeight: true,
				controls: false,
				navPosition: "bottom",
				center: false,
				mouseDrag: true,
				responsive: {
					1024: {
						items: 2
					}
				}
			} );
		});

		$('.image-gallery-one-column').each(function() {
			initSlider( this, {
				items: 1,
				slideBy: 1,
				autoplay: false,
				autoHeight: true,
				controls: false,
				navPosition: "bottom",
				center: false,
				mouseDrag: true,
			} );
		});

		$('.outcome-slider').each(function() {
			initSlider( this, {
				items: 1,
				slideBy: 1,
				edgePadding: 100,
				autoplay: false,
				autoHeight: false,
				controls: false,
				navPosition: "bottom",
				center: true,
				mouseDrag: true,
				autoWidth: true,
			} );
		});

		$('.cards-slider').each(function() {
			initSlider( this, {
				items: 1,
				slideBy: 1,
				autoplay: false,
				autoHeight: false,
				controls: false,
				navPosition: "bottom",
				center: true,
				mouseDrag: true,
				loop: true,
				gutter: 30,
				edgePadding: 20,
				responsive: {
					1024: {
						edgePadding: 200,
					},
					1500: {
						edgePadding: 500,
					}
				}
			} );
		});
	});
})(jQuery);
